import { ref } from 'vue'
import Editor from '@hugerte/hugerte-vue'
import { useHugeRTE } from '../../foundation/js/loadHugeRTE'

export default {
    name: "TextEditor",
    components: {
        Editor
    },
    props: {
        initContent: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const content = ref(props.initContent)
        const { editorReady } = useHugeRTE()

        return {
            content,
            editorReady
        }
    }
}
